import React from 'react'

/* Atoms */
import Button from 'components_new/atoms/Button'

/* Molecules */
import SimpleDialog from 'components_new/molecules/SimpleDialog'

interface TransferModelDialogProps {
  loading?: boolean
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const TransferModelDialog = (props: TransferModelDialogProps) => {
  const { loading, open, onClose, onConfirm } = props

  return (
    <SimpleDialog
      title="Överför modellering till produktion"
      contentText={
        <>
          Modelleringen i testmiljön kommer att kopieras till produktion och{' '}
          <b>ersätta kundens nuvarande produktionsmodellering</b>. Detta går
          inte att ångra. Överföringen kan ta en stund — lämna inte sidan förrän
          den är klar.
        </>
      }
      open={open}
      onClose={loading ? () => null : onClose}
      actions={
        <>
          <Button disabled={loading} onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button loading={loading} onClick={onConfirm} variant="contained">
            Överför
          </Button>
        </>
      }
    />
  )
}

export default TransferModelDialog
